import { render, staticRenderFns } from "./CasePrize.vue?vue&type=template&id=7204f79c&scoped=true&"
import script from "./CasePrize.vue?vue&type=script&lang=js&"
export * from "./CasePrize.vue?vue&type=script&lang=js&"
import style0 from "./CasePrize.vue?vue&type=style&index=0&id=7204f79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204f79c",
  null
  
)

export default component.exports